import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _dec, _obj;
import { LMClick } from '@utils/LMEvent';
import ShareButton from '../../../../../basic/share/index';
import util from '@utils/util';
export default {
  name: 'MessageBox',
  data: function data() {
    return {
      value: '',
      share: 'share-button shan'
    };
  },
  components: {
    'share-button': ShareButton
  },
  methods: (_dec = LMClick('Live-Room'), _obj = {
    disabled: function disabled() {
      return this.value === '';
    },
    shareHandler: function shareHandler() {
      util.KEWLSensorTrack({
        lmweb_clickText: '唤起分享'
      });
      this.share = 'share-button';
    },
    textInputHandler: function textInputHandler(evt) {
      this.value = evt.currentTarget.value;
    },
    submitHandler: function submitHandler() {
      if (!this.value) {
        return;
      }
      this.$emit('submit', this.value);
      this.value = '';
    }
  }, _applyDecoratedDescriptor(_obj, "submitHandler", [_dec], Object.getOwnPropertyDescriptor(_obj, "submitHandler"), _obj), _obj)
};